import PropTypes from "prop-types";
import React from "react";
import { Input, Label, Form, FormFeedback, Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { createSelector } from "reselect";

import withRouter from "../../Components/Common/withRouter";
import { userForgetPassword } from "../../slices/thunks";
import AhAuthShell from "./AhAuthShell";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().email("Enter a valid email").required("Please enter your email"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.history));
    }
  });

  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  const { forgetError, forgetSuccessMsg } = useSelector(selectLayoutProperties);

  document.title = "Reset password | ApiHub";

  return (
    <AhAuthShell
      eyebrow="ACCOUNT RECOVERY"
      title="Forgot your password?"
      subtitle="Enter your email and we'll send you a link to reset it."
      footer={<>Remembered your password? <Link to="/login">Sign in</Link></>}
    >
      {forgetSuccessMsg && (
        <div className="ah-notice" role="status">
          <div className="ah-notice-icon">
            <i className="ri-mail-send-line"></i>
          </div>
          <div className="ah-notice-body">
            <strong>Check your inbox.</strong>
            <div style={{ marginTop: 4, color: "oklch(0.82 0.06 65)" }}>{forgetSuccessMsg}</div>
          </div>
        </div>
      )}

      {forgetError && (
        <div className="alert alert-danger" role="alert" style={{ marginBottom: 20 }}>
          {forgetError}
        </div>
      )}

      <Form
        onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}
      >
        <div className="mb-3">
          <Label className="form-label" htmlFor="email">Email</Label>
          <Input
            id="email"
            name="email"
            placeholder="you@example.com"
            type="email"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.email || ""}
            invalid={validation.touched.email && !!validation.errors.email}
          />
          {validation.touched.email && validation.errors.email && (
            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
          )}
        </div>

        <Button color="primary" className="w-100 mt-2" type="submit">
          Send reset link →
        </Button>
      </Form>
    </AhAuthShell>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
